require('numeral');

// Google Maps script
$(function () {

    // Form styling
    let $input = $('input#zip'),
        $label = $('label.zip-label')

    $input.on('focus click', function(){
        $label.addClass('active')
    })
    $input.on('blur', function(){
        if($(this).val() == '') {
            $label.removeClass('active')
        }
    })
    $input.on('input autocomplete', function() {
        if ($(this).val() != '') {
            $label.addClass('active');
        } else {
            $label.removeClass('active');
        }
    })


    // Find a physician functionality
    let $summary = $('.c-physician-summary'),
        results = {'noResults' : false, 'invalidResults' : false},
        $submitButton = $('#find-physician'),
        $message_begin = $('.physician-message-begin'),
        $noResults = $('.physician-message-no-results'),
        $error = $('.physician-message-error'),
        $flyOut = $('.city-flyout-content'),
        $resultList = $('.results-list-content')

    function noResults(resultStatus, userInput) {
        if(resultStatus === "ZERO_RESULTS" || resultStatus === "NOT_FOUND") {
            if (resultStatus === "ZERO_RESULTS") {
                $flyOut.show().addClass('visible').html('<i class="fal fa-map-marker-alt"></i>' + userInput)
                $error.removeClass('visible')
                $noResults.addClass('visible')
            } else { // NOT FOUND
                results.invalidResults = true

                $flyOut.hide().html('')
                $noResults.removeClass('visible')
                $error.addClass('visible');
            }

            dataLayer.push({
                'event' : 'physicianError'
            })

            $submitButton.prop("disabled", false).html("FIND <i class=\"fas fa-caret-right\"></i>")
        }
    }

    // Retrieve lat and lng from form input to compare against physician lat and lng
    function calcCoordinates(origin) {
        return new Promise(function(resolve, reject){
            let coordinates = {'lat' : '', 'lng' : ''},
                geocoder = new google.maps.Geocoder()

            geocoder.geocode({'address': origin}, function(response, status){
                if(status == google.maps.GeocoderStatus.OK) {
                    coordinates.lat = response[0].geometry.location.lat()
                    coordinates.lng = response[0].geometry.location.lng()
                    resolve(coordinates)
                } else {
                    reject(status)
                }
            })
        })
    }

    function zipDistance(lat1, long1, lat2, long2) {
        let deg2rad = (deg) => {
            return deg * (Math.PI / 180)
        }
        let R = 6371 // Radius of the earth in km
        let dLat = deg2rad(lat2 - lat1)
        let dLon = deg2rad(long2 - long1)
        let a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        let d = (R * c) * 0.63 // convert KM to miles
        return parseFloat(numeral(d).format('0.00'))
    }

    function calculateDistance() {
        $resultList.removeClass('visible')
        $summary.removeClass('active').css('order', '');
        $submitButton.prop("disabled", true).html("<i class=\"fas fa-spinner fa-pulse\"></i>");

        // Remove initial message if one exists
        if($message_begin.length) { $message_begin.hide(); }

        // Remove no results message if one exists
        if($noResults.length) { $noResults.removeClass('visible'); }

        // Remove error message if one exists
        if($error.length) { $error.removeClass('visible'); }

        // Start distance function
        let origin = $('#zip').val(),
            radius = $('#radius').val(),
            withinRadius = []

        calcCoordinates(origin).then(function(response){
            let lat = response.lat,
                lng = response.lng,
                zipOrigin = new google.maps.LatLng(lat, lng)

                // Determine whether or not it is in the mile radius
                $summary.each(function() {  // This loops through the address div in each custom post type
                    let $this = $(this),
                        pLat = $this.data('lat'),
                        pLng = $this.data('lng'),
                        distance = zipDistance(lat, lng, pLat, pLng)

                    if(distance <= radius) {
                        withinRadius.push($(this))
                    }
                })

                if(withinRadius.length > 0){
                    // Determine order for physicians within mile radius
                    for(let i = 0; i < withinRadius.length; i++) {
                        let $this = withinRadius[i],
                            address = $this.find('.practice-address').text(),
                            service = new google.maps.DistanceMatrixService()

                        service.getDistanceMatrix(
                            {
                                origins: [zipOrigin],
                                destinations: [address],
                                travelMode: google.maps.TravelMode.DRIVING,
                                unitSystem: google.maps.UnitSystem.IMPERIAL,
                                avoidHighways: false,
                                avoidTolls: false
                            }, callback)

                        function callback(response, status) {
                            if(status != google.maps.DistanceMatrixStatus.OK) {
                                noResults('NOT_FOUND', zipOrigin)
                            } else {
                                let distance_status = response.rows[0].elements[0].status

                                if(distance_status === 'OK') {
                                    let distance = response.rows[0].elements[0].distance,           // Get distance from the response
                                        miles = (distance.value / 1609),                            // Convert the distance to miles
                                        distance_text = distance.text,                               // Default distance text
                                        formLocation = response.originAddresses[0]

                                    $flyOut.show().addClass('visible').html('<i class="fal fa-map-marker-alt"></i>' + formLocation);

                                    // Checks against radius option from form
                                    if (miles <= radius) {
                                        $this.attr('data-distance', miles).addClass('active')
                                        $this.find('.distance').html(distance_text)                // Display distance from origin to destination on the physician card
                                    }
                                } else {
                                    noResults(distance_status, zipOrigin)
                                }
                            }

                            let physicians = $('.c-physician-summary.active')

                            if(physicians.length > 0) {
                                $noResults.removeClass('visible')
                                $error.removeClass('visible')

                                physicians.sort(function(a, b){
                                    return a.dataset.distance - b.dataset.distance
                                })

                                physicians.each(function (index) {
                                    $(this).css('order', index+1)
                                })

                                dataLayer.push({
                                    'event' : 'physicianSuccess'
                                })

                            } else {
                                noResults('ZERO_RESULTS', zipOrigin)
                            }
                        }
                    }

                    $resultList.addClass('visible')
                    $submitButton.prop("disabled", false).html("FIND <i class=\"fas fa-caret-right\"></i>")

                } else {
                    noResults('ZERO_RESULTS', zipOrigin)
                }
            // }
        }).catch(function(response){
            noResults(response, origin)
        })
    }

    // Form Submission
    $('#find-physician-form').submit(function(e){
        e.preventDefault()
        calculateDistance()
    })
})